/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.25 2.75C6.25 1.2312 7.4812 0 9 0h2c1.5188 0 2.75 1.2312 2.75 2.75v.5H17c1.5188 0 2.75 1.2312 2.75 2.75v3c0 1.5188-1.2312 2.75-2.75 2.75h-6.375V13a.75.75 0 0 1-1.5 0v-1.25H2.75c-.4501 0-.875-.1081-1.25-.2999V17c0 .6904.5596 1.25 1.25 1.25h8.125a.75.75 0 0 1 0 1.5H2.75C1.2312 19.75 0 18.5188 0 17V6c0-1.5188 1.2312-2.75 2.75-2.75h3.5v-.5Zm6 0v.5h-4.5v-.5c0-.6904.5596-1.25 1.25-1.25h2c.6904 0 1.25.5596 1.25 1.25ZM1.5 9c0 .6904.5596 1.25 1.25 1.25H17c.6904 0 1.25-.5596 1.25-1.25V6c0-.6904-.5596-1.25-1.25-1.25H2.75c-.6904 0-1.25.5596-1.25 1.25v3Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M19 24a.75.75 0 0 1-.75-.75v-3.5h-3.5a.75.75 0 0 1 0-1.5h3.5v-3.5a.75.75 0 0 1 1.5 0v3.5h3.5a.75.75 0 0 1 0 1.5h-3.5v3.5A.75.75 0 0 1 19 24Z"
    />
  </React.Fragment>,
  'MenuBusinessInsights'
);
